import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ToastSettings } from "../../../utils/ToastSettings";
import { ArticlesHighlightsService } from "../../../services/Articles/Highlights/ArticlesHighlightsService";

interface ContextProps {
    articlesHighlights: any[],
    isLoading: boolean,
    error: string,
    setError: Dispatch<SetStateAction<string>>,
    handleList: () => void,
    handleFetch: (data: any) => Promise<boolean>,
}

export const ArticlesHighlightsContext = createContext<ContextProps>({} as ContextProps);

interface ArticlesHighlightsProviderProps {
    children: ReactNode;
}

export const ArticlesHighlightsProvider = ({ children }: ArticlesHighlightsProviderProps) => {
    const [articlesHighlights, setArticlesHighlights] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const service = new ArticlesHighlightsService();

    const handleList = async () => {
        try {
            setIsLoading(true);
            const [_Response, _Error] = await service.list();
            setIsLoading(false);

            if (!!_Error) {
                setError(_Response?.message || _Error);
                return false;
            }

            setError('');
            setArticlesHighlights(_Response?.items);
            return true;
        } catch (e: any) {
            setIsLoading(false);
            setError(e.response?.data?.message || 'Não foi possível carregar os artigos destaques do sistema.');
            return false;
        }
    }

    const handleFetch = async (data: any) => {
        try {
            const [_Response, _Error, _Code, _Errors] = await service.fetch(data);
            if (!!_Error) {
                ToastSettings(_Response?.message || _Error, 'bottom-center', 'error', () => { }, _Errors);
                return false;
            }

            setError('');
            return true;
        } catch (e) {
            setError('Houve um erro ao salvar os artigos destaques');
            return false;
        }
    }

    useEffect(() => {
        !!error && toast.error(error);
    }, [error]);

    return (
        <ArticlesHighlightsContext.Provider value={{
            articlesHighlights,
            isLoading,
            error,
            setError,
            handleList,
            handleFetch
        }}>
            {children}
        </ArticlesHighlightsContext.Provider>
    );
}

export const useArticlesHighlights = () => useContext(ArticlesHighlightsContext);